import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackButton from '../../components/BackButton';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';

function Register() {
    const navigate = useNavigate();
    const { theme } = useTheme();
    const { register, isLoading } = useAuth();

    const [handle, setHandle] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const isMobile = window.innerWidth <= 768;

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (!handle.trim() || !password) {
            setError('Complete all fields.');
            return;
        }

        if (!/^[a-z0-9_]{3,24}$/.test(handle.trim().toLowerCase())) {
            setError('Handle must be 3-24 chars: lowercase letters, numbers, underscore.');
            return;
        }

        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        try {
            setSubmitting(true);
            await register({
                handle: handle.trim().toLowerCase(),
                password,
            });
            navigate('/');
        } catch (requestError) {
            setError(requestError.message || 'Sign up failed');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: theme.bgMedium,
            color: theme.textPrimary,
            padding: isMobile ? '16px' : '24px',
        }}>
            <BackButton to="/" />
            <div style={{
                maxWidth: '520px',
                margin: '80px auto 0',
                backgroundColor: theme.bgDark,
                border: `2px solid ${theme.secondary}`,
                borderRadius: '12px',
                padding: isMobile ? '16px' : '24px',
            }}>
                <h1 style={{ marginTop: 0 }}>Create Account</h1>
                <p style={{ marginTop: 0, color: theme.textSecondary }}>
                    Privacy-first account: only a handle + password. No real name or email required.
                </p>

                <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '12px' }}>
                    <label style={{ display: 'grid', gap: '8px' }}>
                        <span>Handle</span>
                        <input
                            value={handle}
                            onChange={(e) => setHandle(e.target.value.toLowerCase())}
                            autoComplete="username"
                            placeholder="player_one"
                            style={{
                                padding: '12px',
                                borderRadius: '8px',
                                border: `2px solid ${theme.secondary}`,
                                backgroundColor: theme.bgMedium,
                                color: theme.textPrimary,
                                fontFamily: 'inherit',
                            }}
                        />
                    </label>

                    <label style={{ display: 'grid', gap: '8px' }}>
                        <span>Password</span>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="new-password"
                            style={{
                                padding: '12px',
                                borderRadius: '8px',
                                border: `2px solid ${theme.secondary}`,
                                backgroundColor: theme.bgMedium,
                                color: theme.textPrimary,
                                fontFamily: 'inherit',
                            }}
                        />
                    </label>

                    <label style={{ display: 'grid', gap: '8px' }}>
                        <span>Confirm Password</span>
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            autoComplete="new-password"
                            style={{
                                padding: '12px',
                                borderRadius: '8px',
                                border: `2px solid ${theme.secondary}`,
                                backgroundColor: theme.bgMedium,
                                color: theme.textPrimary,
                                fontFamily: 'inherit',
                            }}
                        />
                    </label>

                    {error && (
                        <div style={{ color: theme.danger }}>{error}</div>
                    )}

                    <button
                        type="submit"
                        disabled={submitting || isLoading}
                        style={{
                            padding: '12px 16px',
                            borderRadius: '8px',
                            border: 'none',
                            backgroundColor: theme.accent,
                            color: theme.textPrimary,
                            fontFamily: 'inherit',
                            fontWeight: 'bold',
                            cursor: submitting || isLoading ? 'not-allowed' : 'pointer',
                            opacity: submitting || isLoading ? 0.7 : 1,
                        }}
                    >
                        {submitting ? 'Creating Account...' : 'Create Account'}
                    </button>
                </form>

                <button
                    onClick={() => navigate('/login')}
                    style={{
                        marginTop: '12px',
                        background: 'none',
                        border: 'none',
                        color: theme.accent,
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        padding: 0,
                    }}
                >
                    Already have an account? Sign in.
                </button>
            </div>
        </div>
    );
}

export default Register;
